<template>
  <ModalBase :boxShadow="modalBoxShadow" baseBackground="rgb(255 255 255 / 42%)"
    ><div class="info-modal" :class="helpHome ? 'help-home' : ''">
      <CloseModalButton @closeModal="closeModal" />
      <HelpCenterTitle />
      <HelpCenter v-if="helpHome" @setHelpArea="setHelpArea" />
      <InfoSidebar
        v-if="!helpHome"
        :tabs="tabs"
        :currentTab="currentTab"
        @setTabByURL="setTabByURL"
        @backToHelp="backToHelp"
      />
      <InfoArea v-if="!helpHome" />
    </div>
  </ModalBase>
</template>

<script>
import ModalBase from "../../InfoModalBase/ModalBase.vue";
import CloseModalButton from "../CloseModalButton/CloseModalButton.vue";
import HelpCenter from "./HelpCenter.vue";
import HelpCenterTitle from "./HelpCenterTitle.vue";
import InfoSidebar from "./InfoSidebar.vue";
import InfoArea from "./InfoArea.vue";

export default {
  name: "InfoModal",
  components: {
    ModalBase,
    CloseModalButton,
    HelpCenter,
    HelpCenterTitle,
    InfoSidebar,
    InfoArea,
  },
  data() {
    return {
      helpHome: false,
      modalBoxShadow:
        "rgb(15 15 15 / 5%) 0px 0px 0px 1px, rgb(15 15 15 / 10%) 0px 3px 6px, rgb(213 213 213 / 20%) 0px 9px 24px",

      currentTab: "",

      helpAreas: {
        faq: false,
        guides: false,
        community: false,
        troubleshoot: false,
        safety: false,
        legal: false,
      },

      tabs: [
        // {
        //   url: "about",
        //   name: "About",
        // },
        {
          url: "privacy",
          name: "Privacy",
        },
        {
          url: "terms",
          name: "Terms",
        },
        {
          url: "acceptableuse",
          name: "Acceptable Use",
        },
        {
          url: "cookies",
          name: "Cookies",
        },
        {
          url: "contact",
          name: "Contact",
        },
      ],
    };
  },
  methods: {
    closeModal() {
      this.$store.dispatch("modals/setModalState", {
        modal: "helpCenter",
        newState: false,
      });
    },
    backToHelp() {
      this.helpHome = true;
    },
    setHelpArea(area) {
      this.helpHome = false;
      this.helpAreas[area] = true;
    },
  },
};
</script>

<style scoped>
.info-modal {
  height: 800px;
  width: 1200px;
  box-sizing: border-box;
  position: relative;
  display: flex;
  justify-content: center;
  padding: 0px 30px;
  overflow-y: hidden;
}
.help-home {
  padding: 0px 5px;
  overflow-y: scroll;
  padding-top: 60px;
  padding-bottom: 30px;
}
</style>